function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B0BEC5",
  d: "M24.062 26.767l-9.576 9.576-2.121 3.536L7.414 42 6 40.586l2.121-4.95 3.536-2.121 9.576-9.576 2.829 2.828z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFC107",
  d: "M27.597 26.06c-2.121 4.95-3.313 2.343-5.656 0-2.343-2.343-4.95-3.535 0-5.656 4.949-2.122 9.192-10.607 11.313-12.729s4.729-2.343 7.071 0c2.343 2.343 2.121 4.95 0 7.071S29.719 21.11 27.597 26.06z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#455A64",
  d: "M21.94 26.06c2.343 2.343 3.535 4.95 5.656 0l-5.656-5.656c-4.95 2.12-2.342 3.313 0 5.656z"
});

var Svg21Screwdriver = function Svg21Screwdriver(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 344,
    height: 344,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg21Screwdriver, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/21-screwdriver.59006886.svg";
export { ForwardRef as ReactComponent };